import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { environment } from '../environment.ts/environment';

@Component({
  selector: 'app-conditions-generales-ventes',
  standalone: true,
  imports: [HeaderComponent, FooterComponent],
  templateUrl: './conditions-generales-ventes.component.html',
  styleUrl: './conditions-generales-ventes.component.scss'
})
export class ConditionsGeneralesVentesComponent implements OnInit {
  supportEmail = environment.supportEmail;

  constructor(
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit(): void {
    // Définir le titre de la page (50 caractères - optimal)
    this.title.setTitle('Conditions générales de vente – PDF to Word en ligne');
    
    // Définir les meta tags SEO (160 caractères - optimal)
    this.meta.updateTag({ name: 'description', content: 'Consultez les conditions générales de vente du service pdf-to-word.fr : accès, paiements, abonnements, résiliation, sécurité et droit de rétractation.' });
    this.meta.updateTag({ name: 'keywords', content: 'CGV pdf-to-word, conditions générales vente PDF, conditions utilisation conversion PDF, droit rétractation PDF Word, abonnement PDF Word' });
    
    // Meta tags supplémentaires pour le SEO
    this.meta.updateTag({ property: 'og:title', content: 'Conditions générales de vente – PDF to Word en ligne' });
    this.meta.updateTag({ property: 'og:description', content: 'Consultez les conditions générales de vente du service pdf-to-word.fr : accès, paiements, abonnements, résiliation, sécurité et droit de rétractation.' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
    this.meta.updateTag({ name: 'author', content: 'Interactive Lab' });
  }

}
